import type {
  AccountBranding,
  AccountBrandingUpdateData,
  Font,
  FontFamily,
  ImageUploadResponse,
  NormalisedAccountBranding,
} from "models/types/agency-settings";
import { apiClient } from "utils/api-client";
import { createModel } from "utils/models";
import { normaliseAccountBranding } from "utils/normalise-account-branding";

export type AppearanceFormValues = Omit<
  AccountBranding,
  "heading_font_family" | "body_font_family"
> & {
  heading_font_family: Font | FontFamily | null;
  body_font_family: Font | FontFamily | null;
};

export const accountBrandingModel = createModel("accountBranding", {
  queries: {
    get: () => ({
      queryKey: ["accountBranding"],
      queryFn: async (): Promise<NormalisedAccountBranding> => {
        const response =
          await apiClient.get<AccountBranding>("accounts/branding");

        return normaliseAccountBranding(response);
      },
    }),
  },
  mutations: {
    update: () => ({
      mutationKey: ["accountBranding", "update"],
      mutationFn: async (data: AccountBrandingUpdateData) => {
        const response = await apiClient.patch<AccountBranding>(
          "accounts/branding",
          data,
        );
        return response;
      },
    }),
    uploadImage: () => ({
      mutationKey: ["accountBranding", "uploadImage"],
      mutationFn: async (params: { file: File; scale?: number }) => {
        const { file, scale = 1 } = params;
        const response = await apiClient.upload<ImageUploadResponse>(
          "accounts/images",
          file,
          { scale },
        );
        return response;
      },
    }),
  },
});
